import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'

function Dyspnea(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-02-dyspnea-page"}>
            <div className="pageWrapper">
                <DetailHeader diseaseName={"Dyspnea"}></DetailHeader>
                <div className="MainContent">
                    <div className="container">
                        <div className="page-rte">
                            <p>
                                Dyspnea, also called <b>shortness of breath,</b> is a tight feeling in your chest where you may not be able to take a deep breath. This is a symptom that can be linked to many different conditions, like asthma, heart failure and lung disease.
                            </p>
                            <div className="row">
                                <div className="col-12 textCenter">
                                    <img src={require("../../img/Disease/Dyspnea/1.png")} alt="dyspnea" />
                                </div>
                            </div>
                            <br />
                            <p>
                                <b>Symptoms</b>
                            </p>
                            <p>
                                The main symptom of dyspnea is labored breathing. It may last for
                                1 or 2 minutes after strenuous activity. Or it could be a chronic
                                symptom that persists over longer periods, according to the <a className="links" href='https://www.nhs.uk/conditions/shortness-of-breath/' > National Health Service.</a>
                            </p>

                            <p>Dyspnea that occurs after <a className="links" href="https://www.healthline.com/health/strenuous-exercise" tar>strenuous exercise</a> is understandable.</p>
                            <a className="links" href="https://en.wikipedia.org/wiki/Shortness_of_breath" >For More Details</a>
                        </div>
                    </div>
                </div>
            </div>
        </PageWrapper>
    );
}

export default Dyspnea;